import { BCMSDefaultModel, BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Card, Merchant } from "model";

/**
* @class CardOnFileMerchant
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.cardOnFileMerchants[0];
* const CardOnFileMerchant = new transaction(record);
* @property {STRING} _id - id of the cardOnFileMerchant
* @property {CARD} _card - type of cardOnFileMerchant
* @property {MERCHANT} _merchant - type of cardOnFileMerchant
*/

export default class CardOnFileMerchant extends BCMSRecord {
  _id 
  _card
  _merchant
  _status
  _doYouWantToContinueWithTheUpdate
  _didYouStoreYourCardWithThisMerchant
  _howWouldYouLikeToReceiveTheSecurityToken
  _securityToken
  _verificationMerchantUsername
  _verificationMerchantPassword
  _verificationMerchantSecurityCode

  constructor(record) {
    super(record)
  }

    /**
   * @function getClearedCardOnFileMerchant
   * @property {CardOnFileMerchant} cardOnFileMerchant - Instance of cardOnFileMerchant
   * @returns {CardOnFileMerchant}
   * @static
   * @description - Returns an instance of CardOnFileMerchant but with cleared properties, except for the
   * card and merchant. This function is used to clear the fields of the workflow its used in.
   * @memberof Destination
   */
  static getClearedCardOnFileMerchant(cardOnFileMerchant) {
    const defaultCardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();
    defaultCardOnFileMerchant.id = cardOnFileMerchant.id;
    defaultCardOnFileMerchant.merchant = cardOnFileMerchant.merchant;
    defaultCardOnFileMerchant.card = cardOnFileMerchant.card;
    return defaultCardOnFileMerchant;
  }
}

CardOnFileMerchant.define({
  "recordType": "cardOnFileMerchants",
  "recordIDProp": "id",
  "className" : "CardOnFileMerchant",
  "recordProperties": [
   
    /** 
    * @name id
    * @instance
    * @property get {STRING} - gets the id of the cardOnFileMerchant 
    * @property set {STRING} - sets the id of the cardOnFileMerchant 
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("id", "_id"),

    /** 
     * @name card
     * @instance
     * @property get {Merchant} - gets the card of the transactionDispute
     * @property set {Merchant} - sets the card of the transactionDispute 
     * @memberof cardOnFileMerchant
     */
    BCMSRecordProperty.mapToClass("card", "_card", () => Card),

    /** 
     * @name merchant
     * @instance
     * @property get {Merchant} - gets the merchant of the transactionDispute
     * @property set {Merchant} - sets the merchant of the transactionDispute 
     * @memberof cardOnFileMerchant
     */
    BCMSRecordProperty.mapToClass("merchant", "_merchant", () => Merchant),

    /** 
    * @name status
    * @instance
    * @property get {STRING} - gets the status of the cardOnFileMerchant 
    * @property set {STRING} - sets the status of the cardOnFileMerchant 
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("status", "_status"),

    /** 
    * @name doYouWantToContinueWithTheUpdate
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("doYouWantToContinueWithTheUpdate", "_doYouWantToContinueWithTheUpdate"),

    /** 
    * @name didYouStoreYourCardWithThisMerchant
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("didYouStoreYourCardWithThisMerchant", "_didYouStoreYourCardWithThisMerchant"),

    /** 
    * @name howWouldYouLikeToReceiveTheSecurityToken
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("howWouldYouLikeToReceiveTheSecurityToken", "_howWouldYouLikeToReceiveTheSecurityToken"),

    /** 
    * @name securityToken
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("securityToken", "_securityToken"),

    /** 
    * @name verificationMerchantUsername
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantUsername", "_verificationMerchantUsername"),

    /** 
    * @name verificationMerchantPassword
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantPassword", "_verificationMerchantPassword"),

    /** 
    * @name verificationMerchantSecurityCode
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof cardOnFileMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantSecurityCode", "_verificationMerchantSecurityCode"),

  ]
})
